import styled from 'styled-components'

export const DateDisplay = styled.div``
export const TimeDisplay = styled.div`
  font-size: 0.8em;
`
